import React, { useContext } from 'react'
import * as Icon from '@desenvolvimento-intuix/ui-icons'

// eslint-disable-next-line no-unused-vars
import { OrderContext } from '../../contexts/order'

import { Container, ButtonASC, ButtonDESC } from './styles'

interface IProps {
  column: string
}

export const Order: React.FC<IProps> = ({ column }) => {
  const { order } = useContext(OrderContext)

  const isSelectedASC = () => {
    let response = false

    if (column === order?.column && order.type === 'asc') {
      response = true
    }

    return response
  }

  const isSelectedDESC = () => {
    let response = false

    if (column === order?.column && order.type === 'desc') {
      response = true
    }

    return response
  }

  return (
    <Container className='table-order'>
      <ButtonASC type='button' selected={isSelectedASC()}>
        <Icon.ChevronUp />
      </ButtonASC>
      <ButtonDESC type='button' selected={isSelectedDESC()}>
        <Icon.ChevronDown />
      </ButtonDESC>
    </Container>
  )
}
